import { Injectable } from "@angular/core";
import type { Stripe } from "@stripe/stripe-js";
import { environment } from "src/environments/environment";

/**
 * Loads Stripe.js on demand (billing flows only). Uses dynamic import so
 * js.stripe.com / m.stripe.com are not touched during unrelated route loads.
 */
@Injectable({ providedIn: "root" })
export class StripeLoaderService {
  private stripePromise: Promise<Stripe | null> | null = null;

  load(): Promise<Stripe | null> {
    if (!this.stripePromise) {
      this.stripePromise = import("@stripe/stripe-js").then(({ loadStripe }) =>
        loadStripe(environment.STRIPE_PUBLISHABLE_KEY),
      );
    }

    return this.stripePromise;
  }
}
